self.onmessage = function (e) {
  let { provincelist, citylist, countylist, id, name } = e.data;
  initAddressData(provincelist, citylist, countylist, id, name);
};

function initAddressData (provincelist, citylist, countylist, id, name) {
  if (provincelist === null || provincelist === undefined) {
    return;
  }

  let provinces = [];
  let cities = {};
  let counties = {};
  provincelist.forEach(province => {
    provinces.push({
      name: province[name],
      id: province[id]
    });
    let cityArry = [];
    citylist.forEach(city => {
      if (city.ParentId === province[id]) {
        cityArry.push({
          name: city[name],
          id: city[id]
        });
      }
      let countyArry = [];
      countylist.forEach(county => {
        if (county.ParentId === city[id]) {
          countyArry.push({
            name: county[name],
            id: county[id]
          });
        }
      });
      counties[city[id]] = countyArry;
    });
    cities[province[id]] = cityArry;
  });

  provinces.forEach(provinceItem => {
    cities[provinceItem.id].forEach(cityItem => {
      cityItem.children = counties[cityItem.id];
    });
    provinceItem.children = cities[provinceItem.id];
  });
  self.postMessage(provinces);
}



// WEBPACK FOOTER //
// ./~/vue-xpc/src/plugins/address/address.worker.js